/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Privacy_DescriptionInputs */

const en_legal_privacy_description = /** @type {(inputs: Legal_Privacy_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What personal data we collect, why, and your rights.`)
};

const pl_legal_privacy_description = /** @type {(inputs: Legal_Privacy_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jakie dane osobowe zbieramy, w jakim celu i jakie masz prawa.`)
};

/**
* | output |
* | --- |
* | "What personal data we collect, why, and your rights." |
*
* @param {Legal_Privacy_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_privacy_description = /** @type {((inputs?: Legal_Privacy_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Privacy_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_privacy_description(inputs)
	return en_legal_privacy_description(inputs)
});